var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91406 17.5026C2.91406 20.3869 3.76936 23.2064 5.3718 25.6047C6.97423 28.0029 9.25184 29.8721 11.9166 30.9758C14.5813 32.0796 17.5136 32.3684 20.3425 31.8057C23.1713 31.243 25.7698 29.8541 27.8094 27.8146C29.8489 25.7751 31.2378 23.1766 31.8005 20.3477C32.3632 17.5188 32.0744 14.5866 30.9706 11.9218C29.8669 9.25705 27.9977 6.97944 25.5995 5.377C23.2012 3.77457 20.3817 2.91927 17.4974 2.91927C13.6301 2.92072 9.92161 4.45764 7.18702 7.19223C4.45243 9.92682 2.91551 13.6353 2.91406 17.5026ZM22.6009 17.5026L16.0387 24.0649L13.9879 21.9937L18.479 17.5026L13.9879 13.0102L16.0387 10.9389L22.6009 17.5026Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.04a6bc2b0829bef68cce6d526d143401.svg";
export { ForwardRef as ReactComponent };